﻿export const getLutData = async (): Promise<LutData> => {
    const response = await fetch('/api/mt1535/lut');

    if (!response.ok) {
        throw response;
    }

    return await response.json();
};

export const getFakeLutData = (): LutData => {
    let data =
        {
            Verdensdeler:
                [
                    {
                        VerdensdelKode: "AFR",
                        VerdensdelNavn: "Afrika",
                        LandListe: [{ LandKode: "", LandNavn: "" }]
                    },
                    {
                        VerdensdelKode: "ASI",
                        VerdensdelNavn: "Asia",
                        LandListe: [{ LandKode: "", LandNavn: "" }]
                    },
                    {
                        VerdensdelKode: "EUR",
                        VerdensdelNavn: "Europa untatt Norden",
                        LandListe:
                            [
                                {
                                    LandKode: "LAN",
                                    LandNavn: "Langtvekkistan",
                                    LandKundeveiledningstekst: "<div><p>L&aring;nekassen kan gi stipend og l&aring;n til hele bachelorgraden i dette landet. Merk at det f&oslash;rste &aring;ret av graden&nbsp;likevel ikke blir godkjent som h&oslash;yere utdanning i Norge. <a href=\"http://www.nokut.no/\" target=\"_blank\" rel=\"noopener noreferrer\">Les om godkjenning av utenlandsk utdanning p&aring; NOKUT sine nettsider.</a></p></div>",
                                    Laresteder:
                                        [
                                            {
                                                LarestedId: "HOG",
                                                LarestedLandKode: "LAN",
                                                LarestedNavn: "Hogwarts",
                                            },
                                            {
                                                LarestedId: "SWE",
                                                LarestedLandKode: "LAN",
                                                LarestedNavn: "Sweet Valley High",
                                            },
                                        ]
                                },
                                {
                                    LandKode: "XAN",
                                    LandNavn: "Xanadu",
                                    LandKundeveiledningstekst: "<div><p>L&aring;nekassen kan gi stipend og l&aring;n til hele bachelorgraden i dette landet. Merk at det f&oslash;rste &aring;ret av graden&nbsp;likevel ikke blir godkjent som h&oslash;yere utdanning i Norge. <a href=\"http://www.nokut.no/\" target=\"_blank\" rel=\"noopener noreferrer\">Les om godkjenning av utenlandsk utdanning p&aring; NOKUT sine nettsider.</a></p></div>",
                                    Laresteder:
                                        [
                                            {
                                                LarestedId: "SUN",
                                                LarestedLandKode: "XAN",
                                                LarestedNavn: "Sunnydale High",
                                                LarestedKundeveiledningstekst: "<DIV><SPAN lang=NO-NYN>Ver merksam på at Lånekassen berre gir støtte til treårige bachelorgradar ved denne lærestaden. Toårige diplomas er ikkje godkjende for støtte. På opptaksbeviset må det komme fram at du er teken opp i ein treårig bachelorgrad.</SPAN></DIV>",
                                                UtdanningListe:
                                                    [
                                                        {
                                                            UtdanningsoppleggId: 101,
                                                            OppleggNavn: "Varulver"
                                                        },
                                                        {
                                                            UtdanningsoppleggId: 102,
                                                            OppleggNavn: "Vampyrer"
                                                        },
                                                        {
                                                            UtdanningsoppleggId: 103,
                                                            OppleggNavn: "Hekser"
                                                        },
                                                    ]
                                            },
                                            {
                                                LarestedId: "HAR",
                                                LarestedLandKode: "XAN",
                                                LarestedNavn: "Hardtvig Nissen",
                                                LarestedKundeveiledningstekst: "Vær oppmerksom på at Lånekassen bare gir støtte til treårige bachelorgrader ved dette lærestedet. Toårige diplomas er ikke godkjent for støtte. På opptaksbeviset må det komme fram at du er tatt opp&nbsp;i en treårig bachelorgrad.",
                                                UtdanningListe:
                                                    [
                                                        {
                                                            UtdanningsoppleggId: 201,
                                                            OppleggNavn: "Kokkekunst"
                                                        },
                                                        {
                                                            UtdanningsoppleggId: 202,
                                                            OppleggNavn: "Magedans"
                                                        },
                                                        {
                                                            UtdanningsoppleggId: 203,
                                                            OppleggNavn: "Skuespill"
                                                        },
                                                    ]
                                            },
                                        ]
                                },
                            ]
                    },
                    {
                        VerdensdelKode: "NMA",
                        VerdensdelNavn: "Nord- og Mellom-Amerika",
                        LandListe: [{ LandKode: "", LandNavn: "" }]
                    },
                    {
                        VerdensdelKode: "OSE",
                        VerdensdelNavn: "Oseania",
                        LandListe: [{ LandKode: "", LandNavn: "" }]
                    },
                    {
                        VerdensdelKode: "SAM",
                        VerdensdelNavn: "Sør-Amerika",
                        LandListe: [{ LandKode: "", LandNavn: "" }]
                    },
                ]
        };

    return data;
}


export interface LutData {
    Verdensdeler: VerdensdelViewModel[];
}

export interface VerdensdelViewModel {
    VerdensdelKode: string;
    LandListe:      LandViewModel[];
}

export interface LandViewModel {
    LandKode:       string;
    ValutaKode:     string;
    Sprakvarianter: Sprakvarianter[];
    Laresteder:     LarestedViewModel[];
}

export interface LarestedViewModel {
    LarestedId:             number;
    Sprakvarianter:          Sprakvarianter[];
    LarestedWebAdresse:     string;
    UtdanningsoppleggListe: UtdanningViewModel[];
}

export interface Sprakvarianter {
    Navn:            string;
    SprakKode:       SprakKode;
    Kundeveiledning: string;
}

export type SprakKode = "" | "nb-NO" | "en-US" | "nn-NO";

export interface UtdanningViewModel {
    UtdanningsoppleggId: number;
    Sprakvarianter:      Sprakvarianter[];
}
